'use strict';

require('angular-cookies');

require('angular-messages');

require('angular-resource');

require('angular-local-storage');

require('angular-animate');

require('angular-ui-router');

require('angular-i18n/angular-locale_nl-nl.js');

var _iban = require('iban/iban.js');

var _iban2 = _interopRequireDefault(_iban);

require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./src/app/funnel-vendor/index.js
// module id = 423
// module chunks = 7